import {CurrencyEnum} from '@services/countries/countries.model';
import {
    ICategoryFilter,
    ICourseCatalogueFilter,
} from '@services/course/courses.model';
import {IQuestionFilterParams} from '@services/live-event/live-event.model';
import {
    ILiveEvent,
    ILiveEventsUIFilters,
} from '@services/live-events/live-events.model';
import {Pagination} from './pagination';

export const QueryKey = {
    USER: 'USER',
    PROFILE: 'PROFILE',
    USER_PLAN: (planId: string) => ['plan', planId],
    USER_INVOICES: 'INVOICES',
    USER_PAYMENT_DETAILS: 'PAYMENT_DETAILS',
    USER_PREFERENCE_GOALS: 'PREFERENCE_GOALS',

    TRAINER_DETAILS: (slug: string) => ['TRAINER_DETAILS', slug],
    TRAINER: (slug: string) => ['TRAINER', slug],

    CHECKOUT_PLANS: (currency: CurrencyEnum) => ['CHECKOUT_PLANS', currency],
    ONBOARDING_SURVEY: 'ONBOARDING_SURVEY',
    CHECKOUT_SALES_FUNNEL_TEXT: 'CHECKOUT_SALES_FUNNEL_TEXT',
    COUPON_CODE: (couponSlug: string) => [`COUPON_CODE ${couponSlug}`],

    SEARCH_SUGGEST: (searchInput: string) => ['SEARCH_SUGGEST', searchInput],
    SEARCH_SUGGEST_COURSES: (searchInput: string) => [
        'SEARCH_SUGGEST_COURSES',
        searchInput,
    ],
    SEARCH_SUGGEST_TRAINERS: (searchInput: string) => [
        'SEARCH_SUGGEST_TRAINERS',
        searchInput,
    ],
    SEARCH_SUGGEST_CATEGORIES: (searchInput: string) => [
        'SEARCH_SUGGEST_CATEGORIES',
        searchInput,
    ],
    SEARCH_LIVE_EVENTS: (searchInput: string) => [
        'SEARCH_LIVE_EVENTS',
        searchInput,
    ],

    COURSE: (slug: string) => ['COURSE', slug],
    COURSE_BY_ID: (id: number | string) => ['COURSE_BY_ID', id],
    COURSES_BY_IDS: (
        ids: number[],
        {limit = Pagination.COURSES}: {limit?: number} = {},
    ) => ['COURSES_BY_IDS', ...ids, 'LIMIT:' + limit],

    COURSE_PROGRESS: (courseIds: number[]) => [
        'COURSE_PROGRESS',
        ...courseIds.toSorted((a, b) => a - b),
    ],
    COURSE_WATCHTIME: (courseId: number, videoId?: number) => [
        'COURSE_WATCHTIME',
        courseId,
        videoId,
    ],
    COURSE_UBA_COMPLETED_LESSONS: (courseId: number) => [
        'COURSE_UBA_COMPLETED_LESSONS',
        courseId,
    ],
    DISCUSSION_SPACE_CONTRIBUTIONS: (slug: string) => [
        'DISCUSSION_SPACE',
        slug,
    ],

    // Catalogue
    CATALOGUE_COURSES: ({
        trainers,
        courseType,
        category,
        search,
        sortBy,
    }: ICourseCatalogueFilter) => [
        'CATALOGUE_COURSES',
        'COURSE_TYPE:' + courseType,
        'TRAINERS:' + trainers,
        'SEARCH_TERM:' + search,
        'CATEGORY_SLUG:' + category,
        'SORT_BY:' + sortBy,
    ],
    CATALOGUE_CATEGORIES_COUNTS: (filter: ICourseCatalogueFilter) => [
        'CATALOGUE_CATEGORIES_COUNTS',
        ...QueryKey.CATALOGUE_COURSES({...filter, category: undefined}),
    ],
    CATALOGUE_COURSE_TYPE_COUNTS: (filter: ICourseCatalogueFilter) => [
        'CATALOGUE_COURSE_TYPE_COUNTS',
        ...QueryKey.CATALOGUE_COURSES({...filter, courseType: []}),
    ],
    CATALOGUE_FILTER_INFO: (filter: ICourseCatalogueFilter) => [
        'CATALOGUE_FILTER_INFO',
        ...QueryKey.CATALOGUE_COURSES(filter),
    ],
    CATALOGUE_CATEGORIES: (filter?: ICategoryFilter) => [
        'CATALOGUE_CATEGORIES',
        filter?.sortBy,
    ],
    TRAINERS: 'TRAINERS',

    // Favorites
    COURSE_FAVS: 'COURSE_FAVS',

    // Dashboard
    DASHBOARD_FAVORITE_CATEGORIES_COURSES:
        'DASHBOARD_FAVORITE_CATEGORIES_COURSES',
    DASHBOARD_NEXT_EVENTS: 'DASHBOARD_NEXT_EVENTS',
    DASHBOARD_PAST_EVENTS: 'DASHBOARD_PAST_EVENTS',
    DASHBOARD_PODCASTS: 'DASHBOARD_PODCASTS',
    USER_COURSE_RECOMMENDATIONS: 'USER_COURSE_RECOMMENDATIONS',
    DASHBOARD_HERO_SLIDES: 'DASHBOARD_HERO_SLIDES',

    //Live Events
    LIVE_EVENTS_PAST: ({search}: ILiveEventsUIFilters) => [
        'LIVE_EVENTS_PAST',
        'SEARCH_TERM:' + search,
    ],
    LIVE_EVENTS_UPCOMING: ['LIVE_EVENTS_UPCOMING'],

    //Live Event
    LIVE_EVENT: (slug: string) => ['LIVE_EVENT', slug],
    LIVE_EVENT_RECORDINGS_WATCH_TIME: (id: string) => ['LIVE_EVENT_UBA', id],
    LIVE_EVENT_STREAM: (streamUrl: string) => ['LIVE_EVENT_STREAM', streamUrl],
    LIVE_EVENT_QUESTIONS: (
        webinarId: ILiveEvent['id'],
        sortBy: IQuestionFilterParams['sortBy'],
    ) => ['LIVE_EVENT_QUESTIONS', webinarId, `SORT_BY:${sortBy}`],
    LIVE_EVENT_CHAT_MESSAGES: (webinarId: number) => [
        'LIVE_EVENT_CHAT_MESSAGES',
        webinarId,
    ],

    RECOMMENDATION_PREFERENCE: 'RECOMMENDATION_PREFERENCE',

    CONTINUE_WATCHING: 'CONTINUE_WATCHING',
    COMPLETED_COURSES_COUNT: 'COMPLETED_COURSES_COUNT',
    LOGBOOK_HORSES: 'LOGBOOK_HORSES',
    LOGBOOK_ACTIVITY: 'LOGBOOK_ACTIVITY',

    NOTIFICATION_FEED: (onlyUnread: boolean) => [
        'NOTIFICATION_FEED',
        onlyUnread ? 'ONLY_UNREAD' : 'ALL',
    ],
};
